exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n  .down-eva-ans-btn {\n    background: #132ad0;\n    color: #fff;\n    float: right;\n    padding: 5px 10px;\n    border-radius: 5px;\n    border: 1px solid #b1b1b1;\n}\n.down-eva-ans-btn:hover {\n  background: #3447d6;\n}\n.click-hear-to-upload-left .down-eva-ans-btn i {\n  color: #fff;\n  margin: 0 10px 0 0;\n}\n.job-main-outer-box222222222222 ul {\n  margin: 0;\n  padding: 0;\n}\n.job-main-outer-box222222222222 ul li:last-child {\n  float: right;\n}\n.job-main-outer-box222222222222 ul li {\n  font-size: 14px;\n  margin: 0 0 4px 0;\n}\n.job-main-outer-box222222222222 ul li label {\n  font-weight: bold;\n  margin: 0 15px 0 0;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/student-structure-report/student-structure-report.component.css
// module id = ../../../../../src/app/home/student-structure-report/student-structure-report.component.css
// module chunks = common